import type { AutoCompleteItem } from '@omq/types';

/**
 * Maximum amount of query tags that are rendered per suggestion.
 */
const MAX_AUTO_COMPLETE_TAGS = 3;

/**
 * Prefix that marks a suggestion whose leading tags have been cut off.
 */
const TAG_PREFIX = '...';

/**
 * Build the display text of a single auto complete suggestion.
 *
 * Shared by the rendered suggestion and its screen reader announcement,
 * so both always describe the same thing.
 *
 * @param {AutoCompleteItem} item - suggestion to build the text for
 *
 * @returns {string} display text of the suggestion
 */
export function buildAutoCompleteText(item: AutoCompleteItem): string {
  const { query: tags } = item;

  // combine the last tags to a text
  const text = tags
    .slice(MAX_AUTO_COMPLETE_TAGS * -1)
    .map((tag) => tag.content)
    .join(' ');

  // add prefix if tag count exceeded
  return tags.length > MAX_AUTO_COMPLETE_TAGS ? `${TAG_PREFIX} ${text}` : text;
}
